import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { passwordResetChallenge } from '../../../Controllers/AuthController';
import MfaSetup from './MfaSetup';
import MfaVerify from './MfaVerify';

function SolveChallenge({
  name,
  session,
  userIdForSRP,
  username,
  setError,
  setChallengeResponse,
  setSuccess,
  setIsAuthed,
  onLoginSuccess,
}) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      const resp = await passwordResetChallenge(name, session, userIdForSRP, password, username);

      if (resp === true) {
        setChallengeResponse(false);
        setLoading(false);
        setSuccess('Challenge solved. You can now log-in...');
        return true;
      }

      setError(resp.body);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }

    return false;
  };
  if (name === 'MFA_SETUP') {
    return (
      <MfaSetup
        username={username}
        session={session}
        setError={setError}
        setIsAuthed={setIsAuthed}
        onLoginSuccess={onLoginSuccess}
      />
    );
  }

  if (name === 'SOFTWARE_TOKEN_MFA') {
    return (
      <MfaVerify
        username={username}
        session={session}
        setError={setError}
        setIsAuthed={setIsAuthed}
        onLoginSuccess={onLoginSuccess}
      />
    );
  }

  if (name === 'NEW_PASSWORD_REQUIRED') {
    return (
      <>
        <h3 className="card-title text-center mb-4 mt-2">Your password needs to be changed</h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">New Passord</label>
            <input
              type="password"
              className="form-control"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-100"
          >
            Change password
          </button>
        </form>
      </>
    );
  }

  return null;
}

SolveChallenge.propTypes = {
  name: PropTypes.string.isRequired,
  session: PropTypes.string.isRequired,
  userIdForSRP: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  setChallengeResponse: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  setIsAuthed: PropTypes.func.isRequired,
  onLoginSuccess: PropTypes.func.isRequired,
};

export default SolveChallenge;
